// Nine Lives '84 - four-colour sprites for the retro view.
//
// Bitmaps as rows of characters, top row first: `.` is transparent, `x`
// takes the colour the drawing call asks for, and `1` `2` `3` are fixed
// palette indices (cyan, magenta, white). Sprites face right; the view
// flips them.

export type Bitmap = string[];

export const CAT: Bitmap = [
  '..........x.x.',
  '.x........xxx.',
  '.x.......xx3xx',
  '..x.xxxxxxxx.x',
  '...xxxxxxxxx..',
  '...xxxxxxxxx..',
  '...xxxxxxxxx..',
  '...xx.....xx..',
  '...x.x...x.x..',
  '..............',
];

export const DOG: Bitmap = [
  '....................xx..',
  '...................xxxx.',
  '..................xx3xx.',
  '..xx..............xxxx..',
  '...xx.xxxxxxxxxxxxxxx...',
  '....xxxxxxxxxxxxxxxx....',
  '....xxxxxxxxxxxxxxxx....',
  '....xxxxxxxxxxxxxxxx....',
  '....xx..xx....xx..xx....',
  '....xx..xx....xx..xx....',
  '....xx..xx....xx..xx....',
  '........................',
];

export const DOG_LYING: Bitmap = [
  '........................',
  '........................',
  '........................',
  '........................',
  '........................',
  '..................xxxx..',
  '.xx..............xxxxxx.',
  '..xxxxxxxxxxxxxxxxxxxxx.',
  '..xxxxxxxxxxxxxxxxxxxx..',
  '.xxxxxxxxxxxxxxxxxxxx...',
  'xx.xx.xx........xx.xx...',
  '........................',
];

export const MOUSE: Bitmap = ['.xx...x', 'xxxx.x.', 'xxxxxx.', '.x..x..'];

export const FISH: Bitmap = ['x....xx..', 'xx.xxxxx.', 'xxxxxxxxx', 'xx.xxxx3.', 'x....xx..'];

export const BIRD: Bitmap = [
  '......xx..',
  '.....xxxx2',
  '.x..xxx3x.',
  '.xxxxxxx..',
  '..xxxxxx..',
  '...xxxx...',
  '....x.x...',
  '..........',
];

export const SPIDER: Bitmap = [
  '.x..........x.',
  '..x..xxxx..x..',
  '...xxxxxxxx...',
  '.xxxxxxxxxxxx.',
  'x..xx3xx3xx..x',
  '...xxxxxxxx...',
  '..x..xxxx..x..',
  '.x....xx....x.',
  'x............x',
  '..............',
];

export const CUPID: Bitmap = [
  '....xxxx....',
  '...xxxxxx...',
  '...x3xx3x...',
  '...xxxxxx...',
  '....xxxx....',
  'xx..xxxx..xx',
  'xxxxxxxxxxxx',
  'xx..xxxx..xx',
  '....xxxx....',
  '....xxxx....',
  '....x..x....',
  '...xx..xx...',
  '............',
  '............',
];

export const GIFT: Bitmap = [
  '...3.3..',
  '....3...',
  'xxxx3xxx',
  '33333333',
  'xxxx3xxx',
  'xxxx3xxx',
  'xxxx3xxx',
  'xxxx3xxx',
];

/** A heart 30 wide and 14 tall from the implicit heart curve, crisp pixels. */
export function heartBitmap(): Bitmap {
  const w = 30;
  const h = 14;
  const rows: string[] = [];
  for (let j = 0; j < h; j++) {
    let row = '';
    for (let i = 0; i < w; i++) {
      // Map the pixel into the curve's frame: x in -1.35..1.35, y in -1.2..1.4.
      const x = ((i + 0.5) / w) * 2.7 - 1.35;
      const y = 1.4 - ((j + 0.5) / h) * 2.6;
      const a = x * x + y * y - 1;
      row += a * a * a - x * x * y * y * y < 0 ? 'x' : '.';
    }
    rows.push(row);
  }
  return rows;
}

export const HEART = heartBitmap();

/** The broken heart: the same shape with a jagged crack down the middle. */
export const HEART_BROKEN: Bitmap = HEART.map((row, j) => {
  const crack = 14 + (j % 3 === 0 ? 1 : j % 3 === 1 ? 0 : -1);
  return row
    .split('')
    .map((c, i) => (c === 'x' && Math.abs(i - crack) <= 0 ? '.' : c))
    .join('');
});
